<template>
  <div class="mb-5 pb-5">
    <div v-if="!model.centerHasAssistantsAvailable" class="row mb-4">
      <TextAreaSection
        title="Referir Análisis a la SAEE"
        label="Comentario:"
        class="text-area-reason col"
        :value="isSAEEAnalysisProcess? model.returnedReason :model.centerReason"
        :readonly="true"
      />
    </div>

    <ValidationObserver ref="signature-information-form">
      <SaeeFacilitatorSignature
        ref="signatureFormRef"
        v-if="canShowSignaturePanel"
        title="Firma del Facilitador de la Secretaría Asociada de Educación Especial"
        principal-button-label="Presione aquí para añadir firma de funcionario"
        role-label="Puesto"
        class="mt-5"
        :allow-add-more="allowAddSignature"
        :limit-new-signatures-to="1"
        :cannot-edit-name="true"
        :keep-signed="true"
        :use-role="true"
        :requesters="model.signersSaee"
        :submitted="readOnly"
        :validate.sync="invalidSignature"
      />
    </ValidationObserver>
  </div>
</template>

<script>
import alert from '@/mixin/alert.mixin';
import TextAreaSection from '@/components/pei/ubication-tech-assistance/management/_components/TextAreaSection';
import SaeeFacilitatorSignature from '@/components/pei/ubication-tech-assistance/_components/Requesters';
import formDataUtil from '@/utils/formDataUtil';
import { saveSaeeAnalysis } from '@/modules/human-resources/api';
import { requestStatusCodes } from "@/utils/constants/hrrequest/requestStatusCodes";
export default {
  name: 'Tab5AssociateSecretarySpecialEducationAnalysis',
  mixins: [alert],
  components: {
    TextAreaSection,
    SaeeFacilitatorSignature,
  },
  data() {
    return {
      invalidSignature: false,
    };
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    collections: {
      type: Object,
      required: true,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    canShowSignaturePanel: {
      type: Boolean,
      default: true,
    }
  },
  computed: {
    allowAddSignature() {
      return this.model.signersSaee.every((x) => x.isSubmitted);
    },
    model() {
      return this.value;
    },
      isSAEEAnalysisProcess(){ 
      return this.model.statusId == requestStatusCodes.SAEEAnalysisProcess;
    }
  },
  methods: {
    getSaeeAnalysisFormData(submitted) {
      const formData = new FormData();
      formDataUtil.build(formData, this.model.id, 'requestId');
      if (this.model.signersSaee.length) {
        formDataUtil.build(
          formData,
          this.model.signersSaee.map((signer) => ({
            id: signer.id || 0,
            requestId: this.model.id,
            fullName: signer.name,
            rolId: signer.role.id,
            telephoneNumber: signer.phone,
            email: signer.email,
            signed: signer.signed,
            isSubmitted: signer.isSubmitted || !!submitted,
          })),
          'signatures'
        );
      }
      return formData;
    },
    async save(submitted) {
      await saveSaeeAnalysis(this.getSaeeAnalysisFormData(submitted))
        .then(() => {
          this.ShowToast(
            'Confirmación',
            'El análisis ha sido guardado exitosamente.',
            'success'
          );
        })
        .catch((err) => {
          if (err && err.response && err.response.data) {
            this.ShowToast('Error', err.response.data.message, 'error');
          } else {
            this.ShowToast('Error', err.message, 'error');
          }
        });
    },
    async onValidateSignature() {
      const formValidated = await this.$refs[
        'signature-information-form'
      ].validate();

      this.invalidSignature = this.$refs.signatureFormRef ? !this.$refs.signatureFormRef.hasAnyItems : false;

      return formValidated && !this.invalidSignature;
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
::v-deep .text-area-reason textarea {
  min-height: auto !important;
}
</style>
